// src/oura/ui/PanelIcon.tsx
//
// A section icon: a lucide outline stroked in its product area's colour, on
// a transparent ground. No fill and no square, so a card head reads as a
// title with a coloured cue rather than a row of badges.

import type { LucideIcon } from "lucide-react";
import { cn } from "../lib/cn";
import { AREA_TEXT, type Area } from "./tokens";

export interface PanelIconSpec {
    icon: LucideIcon;
    area: Area;
}

/** 20px in a card head, 16px in a tile label. */
export function PanelIcon({ icon: Icon, area, size = 20, className }: PanelIconSpec & { size?: 16 | 20; className?: string }) {
    return <Icon aria-hidden size={size} strokeWidth={2} className={cn("shrink-0", AREA_TEXT[area], className)} />;
}
